<div class="c-routes__gap">
    <span class="c-routes__marker fa fa-angle-right"></span>

    <button 
        type="button" 
        tabindex="-1" 
        class="c-routes__add c-icon-btn"
        [title]="'voyage.addPortCall2' | translate"
        (click)="onAddPortCall()">
        <span class="fa fa-plus"></span>
    </button>
</div> <!-- .c-routes__gap -->